export default __webpack_public_path__ + "static/media/team5.37d214f0.jpg";